import StatCard from "@/components/StatCard";

export default function StatsSection({ jobId, stats, pendingCount, budgetTripped }) {
  return (
    <>
      <section className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-9 gap-3">
        <StatCard testId="stat-total" label="Files" value={stats.total} sub="Uploaded" />
        <StatCard testId="stat-processed" label="Processed" value={stats.processed} sub={`${pendingCount} pending`} />
        <StatCard testId="stat-qualifying" label="Qualifying" value={stats.qualifying} sub="Reports" tone="black" />
        <StatCard testId="stat-pedestrians" label="Pedestrians" value={stats.pedestrians} sub="Non-motorist" />
        <StatCard testId="stat-fatal" label="Fatal · 01" value={stats.fatal} tone="red" />
        <StatCard testId="stat-serious" label="Serious · 02" value={stats.serious} tone="orange" />
        <StatCard testId="stat-minor" label="Minor · 03" value={stats.minor} tone="blue" />
        <StatCard testId="stat-possible" label="Possible · 04" value={stats.possible} sub="+ ambulance" />
        <StatCard testId="stat-possible-nt" label="Possible · 04" value={stats.possibleNoAmb} sub="no transport" />
      </section>

      {/* Discrete cost ticker — always shown when a job exists, even at $0.00,
          so the user knows the field is there. */}
      {jobId && (
        <div className="flex flex-wrap items-center justify-end gap-x-4 gap-y-1 font-mono text-[10px] uppercase tracking-[0.2em]">
          <span
            data-testid="budget-status-pill"
            className={`inline-flex items-center gap-1.5 border px-2 py-0.5 ${
              budgetTripped
                ? "border-[#C1121F] text-[#C1121F] font-bold"
                : "border-zinc-300 text-zinc-500"
            }`}
            title="No live balance API exists — this reflects whether extraction has hit a credit error. Enable auto top-up in your Emergent profile so batches never stall."
          >
            <span
              className={`w-1.5 h-1.5 rounded-full ${budgetTripped ? "bg-[#C1121F]" : "bg-emerald-500"}`}
            />
            {budgetTripped ? "AI credits exhausted" : "AI credits OK"}
            <span className="normal-case tracking-normal opacity-70">· auto top-up: profile → universal key</span>
          </span>
          <span data-testid="est-cost-line" className="opacity-60">
            Est. cost ${(stats.estCostUsd || 0).toFixed(2)} · {stats.llmCalls} AI {stats.llmCalls === 1 ? "call" : "calls"}
          </span>
        </div>
      )}
    </>
  );
}
